export default "__VITE_ASSET__BeWCD13o__"